import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { ExplorerView } from './components/ExplorerView/ExplorerView';
import { DetailView } from './components/DetailView/DetailView';
import { ErrorBoundary } from './components/shared/ErrorBoundary';
import { BasemapProvider, useBasemap } from './context/BasemapContext';
import { WelcomeProvider, useWelcome } from './context/WelcomeContext';
import { FeedbackProvider } from './context/FeedbackContext';
import { BasemapPickerModal } from './components/shared/BasemapPickerModal';
import { WelcomeModal } from './components/shared/WelcomeModal';
import { FeedbackTrigger } from './components/shared/FeedbackTrigger';
import { FeedbackPrompt } from './components/shared/FeedbackPrompt';

function NotFound() {
  return (
    <div className="flex items-center justify-center h-full bg-figma-panel">
      <div className="text-center space-y-4">
        <h1 className="text-title-lg font-roboto font-bold text-figma-text">
          Page not found
        </h1>
        <p className="text-body font-roboto text-neutral-400">
          The page you are looking for does not exist.
        </p>
        <Link to="/" className="inline-block text-figma-lime hover:underline font-roboto text-body">
          Go back to Explorer
        </Link>
      </div>
    </div>
  );
}

function AppShell() {
  const { basemapId, setBasemapId, isPickerOpen, closePicker } = useBasemap();
  const { open: welcomeOpen, close: closeWelcome } = useWelcome();

  return (
    <>
      <ErrorBoundary>
        <div className="flex flex-col h-screen w-screen">
          <div className="flex-1 relative overflow-hidden">
            <Routes>
              <Route path="/" element={<ExplorerView />} />
              <Route path="/detail/:millId" element={<DetailView />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </div>
      </ErrorBoundary>

      <BasemapPickerModal
        open={isPickerOpen}
        currentId={basemapId}
        onPick={(id) => {
          setBasemapId(id);
          closePicker();
        }}
        onClose={closePicker}
      />

      <WelcomeModal open={welcomeOpen} onClose={closeWelcome} />

      {/* Feedback affordances — persistent pill (desktop only) and the
          delayed auto-prompt (desktop toast / mobile centered modal).
          Both open the Google Form in a new tab; embedding via iframe
          was too brittle (Forms blocks the embed when sign-in is
          required). Coordinated via FeedbackContext. */}
      <FeedbackTrigger />
      <FeedbackPrompt />
    </>
  );
}

function App() {
  return (
    <Router>
      <BasemapProvider>
        <WelcomeProvider>
          <FeedbackProvider>
            <AppShell />
          </FeedbackProvider>
        </WelcomeProvider>
      </BasemapProvider>
    </Router>
  );
}

export default App;
